import en from './strings.en';

const ru = {
    createBoards: 'Создать новую площадку',
    invite: 'Пригласить',
    chooseBoards: 'Выберите площадки',
    saved: 'Сохранено'
};

export default { ru, en: { ...ru, ...en} };
